import { GetLayout } from "components/get-layout";
import { RoutePermissionFunction } from "router-manager/parts";

export default function ExtratoOnlineLote() {
  return (
    <GetLayout>
      <></>
    </GetLayout>
  );
}

export const setRoutePermissions: RoutePermissionFunction = (route) => {
  route.addCustomPermission((user) => !!user?.isLogged);
};
